import request from '@/utils/request'
import store from '@/store'
export async function ExceHep2SQL(sql) {
    return request({
        url: 'hep2/execsql',
        method: 'get',
        params: {
            sql
        }
    })
}

export async function GetEmployee(data) {
    return await request({
        url: 'hep2/GetEmployee',
        method: 'get'
    })
}
export async function WorkRoute_ProductD(data) {
    return await request({
        url: 'hep2/WorkRoute_ProductD',
        method: 'get',
        params: data
    })
}
export async function GetVSource(tKey, FieldGrp, sFilter, HEP2DBMark) {
    return await request({
        url: 'hep2/GetVSource',
        method: 'get',
        params: { tKey, FieldGrp, sFilter, HEP2DBMark }
    })
}
export async function GetVSourceW(tKey, FieldGrp, sFilter) {
    return await request({
        url: 'hep2/GetVSourceW',
        method: 'get',
        params: { tKey, FieldGrp, sFilter }
    })
}
export async function RptDetail(tKey, FieldGrp, sFilter, IsW = 0) {
    return await request({
        url: 'hep2/RptDetail',
        method: 'get',
        params: { tKey, FieldGrp, sFilter, IsW }
    })
}
export async function GetBasePage(tKey, FieldGrp, sFilter, page, limit, HEP2DBMark) {
    return await request({
        url: 'hep2/GetBasePage',
        method: 'get',
        params: { tKey, FieldGrp, sFilter, page, limit, HEP2DBMark }
    })
}
export async function YF_getdata(data) {
    return await request({
        url: 'hep2/yf/getdata',
        method: 'get',
        params: data
    })
}
export async function YF_getdatabom(data) {
    return await request({
        url: 'hep2/yf/getdatabom',
        method: 'get',
        params: data
    })
}
export async function UpdateProduceTaskSelfItem9(data) {
    return await request({
        url: 'hep2/yf/updateproducetaskselfitem9',
        method: 'get',
        params: data
    })
}
export async function UpdateProduceTaskSelfItem8(data) {
    return await request({
        url: 'hep2/yf/updateproducetaskselfitem8',
        method: 'get',
        params: data
    })
}
export async function UpdateHep2Row(tablename, field, value, id, HEP2DBMark) {
    return await request({
        url: 'hep2/UpdateHep2Row',
        method: 'get',
        params: { tablename, field, value, id, HEP2DBMark }
    })
}
export async function RptDetailPage(tKey, FieldGrp, sFilter, page, limit, count) {
    return await request({
        url: 'hep2/RptDetailPage',
        method: 'get',
        params: { tKey, FieldGrp, sFilter, page, limit, count }
    })
}

export async function GetNormalField(tablekey, fieldgrp, layoutkey) {
    return await request({
        url: 'hep2/GetNormalField',
        method: 'get',
        params: { tablekey, fieldgrp, layoutkey }
    })
}

export async function GetBillD(BillDKey, FieldGrp, sFilter) {
    const result = await request({
        url: 'hep2/GetBillD',
        method: 'get',
        params: { BillDKey, FieldGrp, sFilter }
    })
    return result.data
}
export async function GetGlobalID(tKey) {
    const data = await request({
        url: 'hep2/GetGlobalID',
        method: 'get',
        params: { tKey, GlobalID: -1 }
    })
    return data.data[0].GlobalID
}
export async function M_SaveBill(data) {
    const result = await request({
        url: 'hep2/M_SaveBill',
        method: 'get',
        params: data
    })
    return result.data
}
export async function ExecProcess(name, data) {
    const result = await request({
        url: 'hep2/' + name,
        method: 'get',
        params: data
    })
    return result.data
}
export async function PutProcess(name, data) {
    const result = await request({
        url: 'hep2/' + name,
        method: 'put',
        data: data
    })
    return result.data
}
export async function ParseErrInfo(sKey, keyid, errinfo) {
    const errinfostr = JSON.stringify(errinfo);
    const result = await request({
        url: 'hep2/ParseErrInfo',
        method: 'put',
        data: {
            KeyID: keyid,
            CmdParam: errinfostr,
            sKey
        }
    })
    alert(result.data[0].ErrInfo)
}
export async function BS_savetable(data) {
    const result = await request({
        url: 'hep2/bs/savetable',
        method: 'put',
        data: data
    })
    return result.data
}
export async function BS_update_gg_wgrkRpt(data) {
    const result = await request({
        url: 'hep2/bs/update_gg_wgrkRpt',
        method: 'get',
        params: data
    })
    return result.data
}
export async function BS_getdaterange(id) {
    const result = await request({
        url: 'hep2/bs/getdaterange',
        method: 'get',
        params: { id }
    })
    return result.data
}
//#region 昌顺
export async function CS_QueryGoods(str) {
    const result = await request({
        url: 'hep2/cs/querygoods',
        method: 'get',
        params: {
            query: str
        }
    })
    return result.data
}
export async function CS_TestGoodsIDCanUe(goodsid) {
    const result = await request({
        url: 'hep2/cs/testgoodsidcanuse',
        method: 'get',
        params: {
            goodsid
        }
    })
    return result.data === true
}
export async function CS_GetAdvice(str) {
    const result = await request({
        url: 'hep2/cs/getadvice',
        method: 'get',
        params: {
            inputcode: str
        }
    })
    return result.data
}
export async function CS_GetLeaveGoods(gtypeid) {
    const result = await request({
        url: 'hep2/cs/getleavegoods',
        method: 'get',
        params: {
            gtypeid: gtypeid
        }
    })
    return result.data
}
export async function CS_GetSalePolicy(gtype) {
    const result = await request({
        url: 'hep2/cs/getSalePolicy',
        method: 'get',
        params: {
            gtype: gtype
        }
    })
    return result.data
}
export async function CS_GetBoomList(gtypeid) {
    const result = await request({
        url: 'hep2/cs/GetBoomList',
        method: 'get',
        params: {
            gtypeid: gtypeid
        }
    })
    return result
}
export async function CS_GetBomInfo(keyid) {
    const result = await request({
        url: 'hep2/cs/GetBomInfo',
        method: 'get',
        params: {
            keyid: keyid
        }
    })
    return result.data
}
export async function CS_ImportAll() {
    const result = await request({
        url: 'hep2/cs/ImportAll',
        method: 'get'
    })
    return result.data
}
export async function CS_ExportBomExcel(filename,keyids) {
    const result = await request({
        url: 'hep2/cs/ExportBomExcel/' + filename,
        method: 'post',
        data: {
            keyids: keyids
        }
    })
    return result
}
export async function CS_RptIoCenterSumM(tKey, sFilter, IOCenterMItemID, SumFilter, Year) {
    const result = await request({
        url: 'hep2/cs/RptIoCenterSumM',
        method: 'get',
        params: {
            tKey: tKey,
            sFilter: sFilter,
            IOCenterMItemID,
            SumFilter,
            Year
        }
    })
    return result
}
//#endregion

export async function ScanByBarCode(tKey, barcode) {
    const result = await request({
        url: 'hep2/flow/scanbybarcode',
        method: 'get',
        params: {
            tKey: tKey,
            barcode: barcode
        }
    })
    return result
}
export async function CheckCanBuildOrShow(Dox, lProperty, DeptID2, WorkTypeID) {
    const result = await request({
        url: 'hep2/CheckCanBuildOrShow',
        method: 'get',
        params: {
            Dox: Dox,
            lProperty: lProperty,
            DeptID2: DeptID2,
            WorkTypeID: WorkTypeID
        }
    })
    return result.data
}
export async function RptFlowDetailBase(tKey, FieldGrp, sFilter, isw) {
    const result = await request({
        url: 'hep2/RptFlowDetailBase',
        method: 'get',
        params: {
            tKey: tKey,
            FieldGrp: FieldGrp,
            sFilter: sFilter,
            isw: isw
        }
    })
    return result.data
}

export function GetFile(filename, fileTable, fileId) {
    return `/api/hep2/GetFile?filename=${filename}&fileTable=${fileTable}&fileId=${fileId}` + '&HEP2DBMark=' + store.state.settings.HEP2DBMark + '&HEP2Database=' + store.state.settings.HEP2Database
}
// #region WJ
export async function WJ_getdata(data) {
    return await request({
        url: 'hep2/wj/getdata',
        method: 'get',
        params: data
    })
}
// #endregion